import { createSelector } from '@reduxjs/toolkit';
import { TenantId } from '../selectors';
import { RootState, store, useAppSelector } from '../store';
import { Device } from '../../services/Native/Device';
import { useEffect } from 'react';
import { updateApiHeaders } from '../api/ApiThunks';
import version from 'config/version.json';

const DynamicHeaders = createSelector(
  (state: RootState) => state.authentication.role,
  (state: RootState) => state.authentication.token,
  (state: RootState) => state.device,
  (state: RootState) => TenantId(state),
  (role, token, device, tenantId) => {
    const nativePlatform =
      device.clientPlatform ??
      (Device.isIOS() ? 'ios' : Device.isAndroid() ? 'android' : undefined);

    let clientName: string;
    if (nativePlatform) {
      const simpleRole = !role || role === 'patient' ? 'patient' : 'team';
      const clientRole = device.clientRole ?? 'patient';
      clientName = `${nativePlatform}-${clientRole ?? simpleRole}`;
    } else {
      const portalPrefix = role === 'patient' ? 'patient-' : role === 'manager' ? 'tenant-' : '';
      clientName = `${portalPrefix}portal`;
    }

    return {
      'client-name': clientName,
      tenant_id: tenantId,
      'client-version': device.clientVersion ?? version['client-version'],
    };
  },
);

const useUpdateApiHeaders = () => {
  const headers = useAppSelector(DynamicHeaders);

  useEffect(() => {
    updateApiHeaders(headers);
  }, [headers]);
};

export default useUpdateApiHeaders;
